import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useQuery } from '@apollo/react-hooks'
import { MessageSquarePlus } from 'lucide-react'
import { SidebarMenu, SidebarMenuButton, SidebarMenuItem } from '@/components/ui/sidebar'
import * as Query from '../../api/gql/query'
import FeedbackDialog from './FeedbackDialog'

/** Bottom-of-sidebar entry point (Freelo #32277899); hidden when the server has no Freelo token. */
const FeedbackButton: React.FC = () => {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)
  const { data } = useQuery(Query.FEEDBACK_ENABLED, { fetchPolicy: 'cache-first' })
  if (!data?.feedbackEnabled) return null
  return (
    <>
      <SidebarMenu>
        <SidebarMenuItem>
          <SidebarMenuButton tooltip={t('Feedback_button')} onClick={() => setOpen(true)}>
            <MessageSquarePlus />
            <span>{t('Feedback_button')}</span>
          </SidebarMenuButton>
        </SidebarMenuItem>
      </SidebarMenu>
      <FeedbackDialog open={open} onOpenChange={setOpen} />
    </>
  )
}

export default FeedbackButton
